/* =========================================================
   PRODUCT DETAIL PAGE — product.js
   Just the quantity stepper. Add-to-cart itself is handled by the
   delegated [data-add] listener in global.js (it reads the current
   value out of #qty-value via data-qty-source).
   ========================================================= */
document.addEventListener("DOMContentLoaded", () => {
  const qtyValueEl = document.getElementById("qty-value");
  if (!qtyValueEl) return;

  let qty = 1;
  document.getElementById("qty-minus")?.addEventListener("click", () => {
    qty = Math.max(1, qty - 1);
    qtyValueEl.textContent = qty;
  });
  document.getElementById("qty-plus")?.addEventListener("click", () => {
    qty = Math.min(99, qty + 1);
    qtyValueEl.textContent = qty;
  });
});
